import { Order } from '../components/attendance/types';
import { ClassStudent } from '../context/types';

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    const sortValueA = a[orderBy];
    const sortValueB = b[orderBy];

    if (typeof sortValueA === 'string' && typeof sortValueB === 'string') {
        return sortValueB.localeCompare(sortValueA);
    }

    if (sortValueB < sortValueA) {
        return -1;
    }

    if (sortValueB > sortValueA) {
        return 1;
    }

    return 0;
}

export function getComparator(order: Order, orderBy): (a, b) => number {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export function getSortName(student: ClassStudent): string {
    const {
        first_name: firstname,
        last_name: lastname,
        user_name: username
    } = student;

    const format = (text: string): string => {
        const specialChars = /[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi;
        return text.replace(specialChars, '').toLowerCase();
    };

    const hasFirstName = firstname && firstname !== '';
    const hasLastName = lastname && lastname !== '';
    const hasUserName = username && username !== '';
    const hasMultiUserName = hasUserName && username.split(' ').length > 1;

    let priority = 0;

    if (hasFirstName && hasLastName) {
        return `${priority}.${format(lastname)}`;
    }

    if (hasMultiUserName) {
        const [, second] = username.split(' ');

        return `${priority}.${format(second)}`;
    }

    priority += 1;

    if (hasLastName) {
        return `${priority}.${format(lastname)}`;
    }

    if (hasFirstName) {
        return `${priority}.${format(firstname)}`;
    }

    if (hasUserName) {
        return `${priority}.${format(username)}`;
    }

    priority += 1;

    return `${priority}.''`;
}
